var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfectiousDisease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.3,17.6L17.7,16l-1.4,0.2h-1.8l-4.2,1.4 c0,0-2.1,1-1.6,5.2v6.1h7h1.2h4l0.1-3.7l2-0.7l1-1.5C24.3,18.2,22.3,17.6,22.3,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16,17.3L16,17.3c-0.8,0-1.4-0.2-1.4-1v-1.7 c0-0.8,0.6-1.4,1.4-1.4l0,0c0.8,0,1.4,0.6,1.4,1.4v1.7C17.4,17.2,16.8,17.3,16,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.7,11c-0.1,0-0.1,0-0.2,0 c-0.3-1.9-1.7-3.4-3.5-3.4c-1.7,0-3.2,1.5-3.5,3.4c-0.1,0-0.2-0.1-0.3,0c-0.3,0.1-0.5,0.5-0.4,1c0.1,0.4,0.4,0.7,0.7,0.7 c0.4,1.8,1.8,3.1,3.4,3.1s3-1.3,3.4-3.1c0.3-0.1,0.5-0.4,0.6-0.7C20.2,11.5,20.1,11.1,19.7,11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M12.5,12l-0.4-1c-0.7-2.1,0.2-3.5,0.2-3.5c1.2-2.4,4.2-2,4.2-2s2.5,0.3,3.4,2.3c0,0,0.9,2-0.6,4.1 L19,10.6c0,0-1.1-0.7-1.3-2.2c0,0-0.5,1.7-2.7,2.1c0,0,0.5-0.9,0.5-1.7c0,0-0.8,2-2.7,1.9L12.5,12z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 16.1,
    y1: 11.8,
    x2: 16.1,
    y2: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.3,20.6l2.1,0.6c0.1,0,0.2,0,0.2-0.1 l0.9-3.5l0,0l0.2-3c0-0.1,0-0.1-0.1-0.1c-2.4-2.1-4.4-0.6-5.1,0.1c-0.2,0.2-0.2,0.4-0.2,0.6v5.6v1H15c0.1,0,0.1-0.1,0.2-0.2v-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2B0",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.5,18.5l-1.7-1.7 c-0.2-0.2-0.2-0.5-0.1-0.7c0.3-0.5,1-1.4,2-1.6c0.3-0.1,0.6,0.1,0.7,0.3l1.1,2.2c0.1,0.3,0.1,0.6-0.2,0.8l-1,0.8 C17.1,18.7,16.7,18.7,16.5,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M18.9,16.9c0.2-0.1,0.4-0.1,0.5,0.1l0,0 l4.4,5.8c0.6,0.9,0.5,2.1-0.4,2.7l-0.2,0.1c-0.9,0.6-2.1,0.5-2.7-0.4l-4.4-5.8c-0.1-0.1-0.1-0.2-0.2-0.3C17,18.4,18,17.6,18.9,16.9 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 24.5,
    y1: 10.6,
    x2: 24.5,
    y2: 15.6
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 26.9,
    y1: 13.1,
    x2: 22,
    y2: 13.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 26.2,
    y1: 11.3,
    x2: 22.7,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 26.2,
    y1: 14.8,
    x2: 22.7,
    y2: 11.3
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 24.5,
    cy: 13.1,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 8.5,
    y1: 10.8,
    x2: 8.5,
    y2: 15.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11,
    y1: 13.3,
    x2: 6.1,
    y2: 13.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 10.3,
    y1: 11.6,
    x2: 6.8,
    y2: 15.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 10.3,
    y1: 15.1,
    x2: 6.8,
    y2: 11.6
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 8.5,
    cy: 13.3,
    r: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 22.1,
    y1: 5.8,
    x2: 22.1,
    y2: 8.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 23.6,
    y1: 7.3,
    x2: 20.6,
    y2: 7.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 23.2,
    y1: 6.3,
    x2: 21,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 23.2,
    y1: 8.4,
    x2: 21,
    y2: 6.3
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 22.1,
    cy: 7.3,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 10.7,
    y1: 3.6,
    x2: 10.7,
    y2: 6.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 12.2,
    y1: 5.1,
    x2: 9.2,
    y2: 5.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11.8,
    y1: 4.1,
    x2: 9.7,
    y2: 6.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 11.8,
    y1: 6.2,
    x2: 9.7,
    y2: 4.1
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 10.7,
    cy: 5.1,
    r: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfectiousDisease);
export default __webpack_public_path__ + "static/media/infectious_disease.4f530329679d8b51754723a5d042a195.svg";
export { ForwardRef as ReactComponent };